import { LicenseProductIdEnum } from '@nirvana/shared/license-helper';

export const RENEWAL_DAYS_UNTIL_AVAILABLE = 370;

export const MAX_SEATS_EXCEEDED_PRODUCT_PAGES = {
  [LicenseProductIdEnum.ProductIdOfficeSecurityPack]:
    'https://pages.bitdefender.com/business/en/ext35bs1-1?cid=gz%7Cb%7Cgravityzone%7Coc-extraseatsbs-en-06-2024%7Con&pid=EXT35GZ',
  [LicenseProductIdEnum.ProductIdCoreOnlineProduct]:
    'https://pages.bitdefender.com/business/en/ext35sbs1-1?cid=gz%7Cb%7Cgravityzone%7Coc-extraseatssbs-en-06-2024%7Con&pid=EXT35GZ',
  [LicenseProductIdEnum.ProductIdNextGen]:
    'https://pages.bitdefender.com/business/en/ext35bsp1-1?cid=gz%7Cb%7Cgravityzone%7Coc-extraseatsbsp-en-06-2024%7Con&pid=EXT35GZ',
  [LicenseProductIdEnum.ProductIdVolumeEncryption]:
    'https://pages.bitdefender.com/business/en/ext35fde1-1?cid=gz%7Cb%7Cgravityzone%7Coc-extraseatsfde-en-06-2024%7Con&pid=EXT35GZ',
  [LicenseProductIdEnum.ProductIdPatchManagement]:
    'https://pages.bitdefender.com/business/en/ext35pm1-1?cid=gz%7Cb%7Cgravityzone%7Coc-extraseatspm-en-06-2024%7Con&pid=EXT35GZ',
  [LicenseProductIdEnum.ProductIdMobileSecurity]:
    'https://pages.bitdefender.com/business/en/ext35mobile1-1?cid=gz%7Cb%7Cgravityzone%7Coc-extraseatsmobile-en-06-2024%7Con&pid=EXT35GZ',
  [LicenseProductIdEnum.ProductIdNadAndEraAddon]:
    'https://www.bitdefender.com/pages/business/en/ext35nad1-1?cid=gz%7Cb%7Cgravityzone%7Coc-extraseatsnad-en%7Con&pid=EXT35GZ',
  [LicenseProductIdEnum.ProductIdWebAccessAndDeviceControlAddon]:
    'https://www.bitdefender.com/pages/business/en/ext35wadc1-1?cid=gz%7Cb%7Cgravityzone%7Coc-extraseatswadc-en%7Con&pid=EXT35GZ',
};

export const BUY_NEW_LICENSE_WINBACK_LINKS = {
  [LicenseProductIdEnum.ProductIdOfficeSecurityPack]:
    'https://pages.bitdefender.com/business/en/bs-2024?cid=gz%7Cb%7Cgravityzone%7Cwinback%7Cen%7Cm%7Con&pid=IPB-WB-35',
  [LicenseProductIdEnum.ProductIdCoreOnlineProduct]:
    'https://pages.bitdefender.com/business/en/sbs-2024?cid=gz%7Cb%7Cgravityzone%7Cwinback%7Cen%7Cm%7Con&pid=IPB-WB-35',
  [LicenseProductIdEnum.ProductIdNextGen]:
    'https://pages.bitdefender.com/business/en/bsp-2024?cid=gz%7Cb%7Cgravityzone%7Cwinback%7Cen%7Cm%7Con&pid=IPB-WB-35',
  [LicenseProductIdEnum.ProductIdVolumeEncryption]:
    'https://pages.bitdefender.com/business/en/fde-2024?cid=gz%7Cb%7Cgravityzone%7Cwinback%7Cen%7Cm%7Con&pid=IPB-WB-35',
  [LicenseProductIdEnum.ProductIdPatchManagement]:
    'https://pages.bitdefender.com/business/en/pm-2024?cid=gz%7Cb%7Cgravityzone%7Cwinback%7Cen%7Cm%7Con&pid=IPB-WB-35',
  [LicenseProductIdEnum.ProductIdMobileSecurity]:
    'https://pages.bitdefender.com/business/en/mobile-2024?cid=gz%7Cb%7Cgravityzone%7Cwinback%7Cen%7Cm%7Con&pid=IPB-WB-35',
  [LicenseProductIdEnum.ProductIdNadAndEraAddon]:
    'https://pages.bitdefender.com/business/en/nad-2024?cid=gz%7Cb%7Cgravityzone%7Cwinback%7Cen%7Cm%7Con&pid=IPB-WB-35',
  [LicenseProductIdEnum.ProductIdWebAccessAndDeviceControlAddon]:
    'https://pages.bitdefender.com/business/en/wadc-2024?cid=gz%7Cb%7Cgravityzone%7Cwinback%7Cen%7Cm%7Con&pid=IPB-WB-35',
};
